import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";
import ScrollToTopLink from "../../ScrollToTopLink";

const NewsCard = ({
  newsItem: { title_en, title_it, body_en, body_it, id, img, date },
  formatDate,
}) => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "it").substring(0, 2);
  const title = lang === "en" ? title_en : title_it;
  const body = lang === "en" ? body_en : body_it;

  return (
    <ScrollToTopLink to={`/news/${id}`} className="text-decoration-none">
      <div className="card mb-4 newscardhover news-archive-card">
        <div className="row g-0 align-items-center">
          {img !== "" && (
            <div className="col-md-4 text-center p-3">
              <img
                src={img}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = "/img/homeBkg.jpg";
                }}
                className="img-fluid rounded_img news-archive-img"
                alt={title}
                loading="lazy"
              />
            </div>
          )}

          <div className={img !== "" ? "col-md-8" : "col-12"}>
            <div className="card-body py-3 px-4">
              <div className="blog-date-badge mb-2">
                <FontAwesomeIcon icon={faCalendar} className="blog-date-icon" />
                <span>{formatDate(date)}</span>
              </div>
              <h4 className="newstitle text-left mb-2">{title}</h4>
              {body && (
                <p className="card-text news-body-text mb-0">
                  {body.split(" ").slice(0, 40).join(" ") + " ..."}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </ScrollToTopLink>
  );
};

export default NewsCard;
